import SocialMedia from './social'

export default SocialMedia